define ['./freeformsWidget.css'], () ->
  (RentappService, $state, $filter) ->
    restrict: "E"
    template: require("./freeformsWidget.jade")
    require: "ngModel"
    scope: { field: "=", mode: "@", stage: "=", apptemp: "=" , index: "="}
    link: (scope, element, attrs, ngModel) ->
      scope.hijack = false
      
      if scope.apptemp and scope.mode == 'edit'
        scope.hijack = !!scope.apptemp.hijack


// WEBPACK FOOTER //
// ./directives/freeforms/freeformsWidget.coffee